import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Snackbar } from '@mui/material';
import { Formik } from 'formik';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import MembershipPlanForm from 'src/components/membership/MembershipForm';
import { addMembershipPlan, getMembershipPlan } from 'src/api/membership';
import { membershipPlanReducerAction } from 'src/redux/reducers/membershipPlan';
import { commonReducerAction } from 'src/redux/reducers/common';

const AddMembershipPlanModal = ({ handleCloseModal }) => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const { updateMembershipPlans } = membershipPlanReducerAction;
  const { logoutUser } = commonReducerAction;
  const dispatch = useDispatch();
  const { user, gymId } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          padding: '.8rem',
          backgroundColor: 'background.default',
          borderRadius: '10px'
        }}
      >
        <Formik
          initialValues={{
            name: '',
            description: '',
            amount: null,
            duration: 0
          }}
          validationSchema={CONSTANTS.membershipPlanValidationSchema}
          onSubmit={async (values) => {
            values.gym_id = gymId;
            try {
              dispatch(startLoading());
              const res = await addMembershipPlan(user, values);
              dispatch(stopLoading());
              const isError = res.status !== 200;
              const message = isError ? res?.message : "MembershipPlan Added Successfully"
              setSnackbarState({
                open: true,
                message: message,
                severity: isError ? 'error' : 'success'
              });
              if (!isError) {
                getMembershipPlan(user, gymId)
                  .then((res) => {
                    if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
                     dispatch(logoutUser());
                    if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
                      dispatch(updateMembershipPlans(res.data?.data));
                    }
                    dispatch(stopLoading());
                    handleCloseModal();
                  })
                  .catch((err) => {
                    dispatch(stopLoading());
                    console.log(err);
                  });
              }
            } catch (err) {
              dispatch(stopLoading());
              setSnackbarState({
                open: true,
                message: err.message,
                severity: 'error'
              });
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            touched,
            values
          }) => (
            <MembershipPlanForm
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
              touched={touched}
              values={values}
              handleCloseModal={handleCloseModal}
              heading={STRINGS.ADD_MEMBERSHIP_PLAN}
            />
          )}
        </Formik>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarState.open}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <div>
            <Alert onClose={handleClose} severity={snackbarState.severity}>
              {snackbarState.message}
            </Alert>
          </div>
        </Snackbar>
      </Container>
    </>
  );
};

export default AddMembershipPlanModal;
